if ($('.governance-bod').length) {
	var currentGrid;
	var $actionBlock = $('.js-bod');

	function scrollToElement(bodContent) {
		var topPos = bodContent.offset().top - $('.js-header-top-nav.is-fixed').height() - 5;
		$('html')
			.velocity('scroll', {
				offset: topPos + 'px',
				duration: 500,
				mobileHA: false
			});
	}

	function slideDown(bodMain) {
		bodMain
			.siblings('.bod-content')
			.velocity('slideDown', {
				duration: 300
			});
	}

	function checkHash() {

		var arrHashes = [];
		var arrAnchorHashes = [];
		const $anchors = $('[data-anchor]');
		for (var i = 0; i < $actionBlock.length; i++) {
			arrHashes[i] = $actionBlock.eq(i).data('hash');
		}

		for (var i = 0; i < $actionBlock.length; i++) {
			arrAnchorHashes[i] = $actionBlock.eq(i).data('hash');
		}

		for (var i = 0; i < $anchors.length; i++) {
			arrAnchorHashes[i] = $anchors.eq(i).data('anchor');
		}

		if (window.location.hash) {
			var hash = window.location.hash.substr(1),
				hashIndexOf = arrHashes.indexOf(hash),
				hashAnchorsIndexOf = arrAnchorHashes.indexOf(`#${hash}`) + 1;

			if (hashIndexOf == -1 & hash != '' && !hashAnchorsIndexOf) {
				window.location.hash = '!';
			} else {
				scrollToHashElement(hash);
			}
		}
	}

	function scrollToHashElement(hash) {

		for (var i = 0; i < $actionBlock.length; i++) {

			if ($actionBlock.eq(i).data('hash') == hash) {
				var $currentMan = $actionBlock.eq(i);
				currentGrid = $currentMan.parents('.grid-content').index('.grid-content');

				slideDown($currentMan);

				$currentMan.addClass('bod-main--selected');

				setTimeout(function () {
					scrollToElement($currentMan);
				}, 300);
			}
		}
	}

	function slideUpSlideDown(bodMain) {

		$actionBlock
			.not(bodMain)
			.siblings('.bod-content')
			.velocity('slideUp', {
				duration: 300
			});

		$actionBlock
			.not(bodMain)
			.removeClass('bod-main--selected');

		setTimeout(function () {
			window.location.hash = bodMain.data('hash');
			currentGrid = bodMain.parents('.grid-content').index('.grid-content');

			slideDown(bodMain);

			bodMain.addClass('bod-main--selected');
		}, 300);

		setTimeout(function () {
			scrollToElement(bodMain);
		}, 300);
	}

	if ($actionBlock.length > 0) {
		checkHash();
	}

	$actionBlock.on('click', function expandContent(e) {
		var $this = $(this);

		if ($(this).siblings('.bod-content').is(':visible')) {
			$(this)
				.siblings('.bod-content')
				.velocity('slideUp', {
					duration: 300
				});

			$this.removeClass('bod-main--selected');

			currentGrid = null;

			window.location.hash = '!';
		} else {
			if (currentGrid == $this.parents('.grid-content').index('.grid-content')) {
				slideUpSlideDown($this);
			} else {
				slideDown($this);
				window.location.hash = $this.data('hash');
				currentGrid = $this.parents('.grid-content').index('.grid-content');

				$this.addClass('bod-main--selected');

				setTimeout(function () {
					scrollToElement($this);
				}, 300);
			}
		}
	});
}



// WEBPACK FOOTER //
// ./temp/components/bod/bod-animated-blocks/index.js